<template>
  <div id="zoom-page">
    <div @mouseover="closeAllModals($event)" id="bg">
    </div>
    <div id="bghover">
    </div>
    <div class="wrapper">
      <div v-if="list">
        <zoom :comparative="comparative" :max="max" :list="list"></zoom>
      </div>
      <div v-else>
        <loading :loading="true"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import Zoom from "@/components/Zoom";

import api from "../api";
export default {
  name: "app",
  data() {
    return {
      list: null,
      max: 0,
      comparative: false
    };
  },
  components: {
    Zoom
  },
  computed: {
    cat() {
      return this.$route.params.cat;
    }
  },
  beforeCreate() {
    document.title = this.$t("titles.zoom");
  },
  mounted() {
    api.getTracker(1).then(res => {
      this.comparative = res.isComparative;
      let all = res.touchpoints;
      let list = [];
      all.forEach((e, i) => {
        if (e.stage.trim() === this.cat) {
          if (this.max < Math.abs(e.negativeIntensity)) {
            this.max = Math.abs(e.negativeIntensity);
          }
          if (this.max < e.positiveIntensity) {
            this.max = e.positiveIntensity;
          }
          e.i = i;
          list.push(e);
        }
      });
      this.max = this.max + 5;
      this.list = list;
    });
    if (document.getElementById("tracker")) {
      document.getElementById("tracker").addEventListener("wheel", e => {
        if (e.type != "wheel") {
          return;
        }
        let delta = (e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1;
        delta = delta - 100;

        if (e.deltaY < 0) {
          document.getElementById("tracker").scrollLeft += delta;
        }
        if (e.deltaY > 0) {
          document.getElementById("tracker").scrollLeft -= delta;
        }
        e.preventDefault();
      });
    }
  },
  methods: {
    closeAllModals(event) {
      var els = document.getElementsByClassName("modal");
      var items = document.getElementsByClassName("item-tracker");
      Array.prototype.forEach.call(els, el => {
        el.classList.remove("active");
      });
      Array.prototype.forEach.call(items, el => {
        el.classList.remove("is-active");
      });
      event.currentTarget.classList.remove("active");
    }
  }
};
</script>

<style lang="scss">
.wrapper {
}
</style>
